import img16a from '../../../assets/gallery/16e/16e-01-HOME_Chapas-2-2016-415x29mm-lapiz-portaminas-HB-sobre-papel-70gr.png';
import img16b from '../../../assets/gallery/16e/16e-02_Chapas1-2016-405x285mm-lapiz portaminas-HB-sobre-papel-70gr.png';
import img16c from '../../../assets/gallery/16e/16e-03_Chapas3-2016-41x29cm-lápiz-portaminas-HB-sobre-papel-70gr.png';
import img16d from '../../../assets/gallery/16e/16e-04_Chapas4-2016-398x290mm-lapiz-portaminas-HB-sobre-papel-70gr.png';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "41,5 x 29 cm",
    pictureSrc: img16a,
    description: "2016",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "40,5 x 28,5 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "41 x 29 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "39,8 x 29 cm",
    pictureSrc: img16d,
    description: "2016",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/16e/data16e.js